import React from 'react';
import { Points } from 'components/Points/Points';
import { AssetUrls } from 'config/assets';
import './CollectionSummary.css';

interface CollectionStats {
  haveListCount: number;
  haveListValue: number;
  wantListCount: number;
  wantListValue: number;
}

interface Props {
  stats: CollectionStats;
}

export default function CollectionSummary({ stats }: Props) {
  return (
    <div className="collection-summary">
      <div className="summary-card">
        <div className="summary-number" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <img
            src={AssetUrls.icons.misc.heart}
            alt="Want List"
            style={{ width: '26px', height: '26px' }}
          />
          {stats.wantListCount}
        </div>
        <div className="summary-label">Cards on Want List</div>
      </div>

      <div className="summary-card points-card">
        <Points points={stats.wantListValue} type="big" />
        <div className="summary-label">Want List Value</div>
      </div>

      <div className="summary-card">
        <div className="summary-number" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <img
            src={AssetUrls.icons.misc.have}
            alt="Have List"
            style={{ width: '26px', height: '26px' }}
          />
          {stats.haveListCount}
        </div>
        <div className="summary-label">Cards in Collection</div>
      </div>

      <div className="summary-card points-card">
        <Points points={stats.haveListValue} type="big" />
        <div className="summary-label">Collection Value</div>
      </div>
    </div>
  );
}